import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Chip,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import { Delete, KeyboardBackspace } from "@material-ui/icons";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import instance, { baseUrl } from "api/globalaxios";
import { isLoggedIn } from "slices/loginSlice";
import { getTempDetails } from "features/TempTiacForm/ClaimantPage/questions";
import { GetAnswersTiac } from "features/TempTiacForm/Tiacfinal/final";
import { getQuestionsTiac } from "features/TempTiacForm/UploadPage/questions";
import { DropzoneDialog } from "material-ui-dropzone";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import Swal from "sweetalert2";
import { useSnackbar } from "contexts/SnackbarContext";
import FormError from "../Components/FormError";
import OrderDraftsTable from "../Components/OrderDraftsTable";
import FullscreenToggle from "../Components/FullscreenToggle";
import { downloadLegalDoc, getRealhost } from "slices/disputeSlice";
// import { formatDate } from "utils";
import GeneralActivitiesACCB from "../GeneralActivitiesACCB";
import {
  safeDateFormat,
  downloadDefectMemo,
  displayEmail,
  buildHearingDatesHtml,
  isCaseReopened,
  getPartyOrganisation,
  isAllowedAmountInput,
  allowsMultipleDrafts,
  nextDraftTitle,
} from "../utils";
import { getCaseTimeline, getCaseScrutinyDocs, getScrutinyDocumentPreview, reuploadScrutinyDocument } from "../service";
import { downloadTrustedUrlInIframe, navigateToTrustedUrl, openTrustedUrl } from "../urlSafety";
import { fetchOrderShortcuts, buildShortcutMap, createShortcutExpansion } from "../orderShortcuts";
import { documentPreset } from "Components/RichTextEditor";
import OrderSheetEditor, {
  ORDER_PAGE_ITEMS,
  PostMatterLinks,
  printOrderSheet,
  ShortcutsButton,
  usePostMatterLinks,
} from "../Components/OrderSheet";
import MicIcon from "@material-ui/icons/Mic";
import { authenticateDocMgmt, isDocMgmtAuthenticated, uploadDocMgmtFile, deleteDocMgmtFile } from "../filesACCB/DocMgmtApi";
import { getRequestConfig } from "../filesACCB/FileApi";
import MandateClock from "../Components/MandateClock";
import PartyPendingPayments from "../Components/Financial/PartyPendingPayments";
import ShowProgress from "../Components/ShowProgress";
import RecordOfProceedings from "../Components/RecordOfProceedings";
import BookHearingRoom from "../Components/BookHearingRoom";
import RecordOfDirections from "../Components/RecordOfDirections/RecordOfDirections";
import Adjournments from "../Components/Adjournments";
import AdjournmentRequests from "../Components/AdjournmentRequests";

const useStyles = makeStyles((theme) => ({
  dropzonePreviewItem: {
    maxWidth: "100%",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  },
  root: {
    marginTop: "2rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "1.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem",
    },
  },
  btntext: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    textTransform: "none",
  },
  paperPartiesInvolved: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "3rem",
    [theme.breakpoints.down("md")]: {
      padding: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
  PartiesInvolvedHeading: {
    fontWeight: "600",
    marginBottom: "1rem",
    fontSize: "1.2rem",
    lineHeight: "1.5rem",
    color: "black",
  },
  PartiesInvolvedText: {
    color: TEXT.secondary,
    fontSize: "14px",
    fontWeight: "500",
    // fontFamily: `'Inter',sans-serif`,
    marginBottom: "0.6rem",
  },
  paperDisputeDetails: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    // Padding and border inside the 100% width, so a card never runs wider
    // than its grid column (there is no global border-box reset here).
    boxSizing: "border-box",
    minWidth: 0,
    padding: "2rem",
    border: "1px solid #E5E5E5",
    [theme.breakpoints.down("md")]: {
      padding: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
  disputeNameHeading: {
    fontWeight: "600",
    fontSize: "1.2rem",
    lineHeight: "1.5rem",
    color: "black",
  },
  text: {
    color: TEXT.secondary,
    fontSize: "16px",
    fontWeight: "400",
    // fontFamily: `'Inter',sans-serif`,
  },
  bluetext: {
    color: TEXT.info,
    fontSize: "16px",
    fontWeight: "400",
    // fontFamily: `'Inter',sans-serif`,
  },
  btnTextWhite: {
    color: TEXT.onDark,
    fontSize: "18px",
    fontWeight: "400",
    // fontFamily: `'Inter',sans-serif`,
    textTransform: "none",
  },
  btnTextBlack: {
    color: TEXT.secondary,
    fontSize: "16px",
    fontWeight: "400",
    // fontFamily: `'Inter',sans-serif`,
    textTransform: "none",
  },
  generate: {
    fontSize: "18px",
    color: `${theme.palette.primary.main}`,
    textTransform: "none",
    textDecoration: "underline",
  },
  activityText: {
    fontSize: "28px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: TEXT.secondary,
    marginLeft: "2rem",
  },
  activityPaper: {
    border: "1px solid #BDBDBD",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
    padding: "2rem 2rem 1.3rem 2rem",
  },
  activityUsername: {
    fontSize: "18px",
    fontWeight: 400,
    // fontFamily: `'Inter',sans-serif`,
    color: TEXT.info,
  },
  activityheading: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: TEXT.primary,
    wordBreak: "break-word",
  },
  activityTime: {
    fontSize: "12px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: TEXT.primary,
    wordBreak: "break-word",
  },
  activityfileFolderName: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: TEXT.strong,
    wordBreak: "break-word",
  },
  decision: {
    fontSize: "16px",
    fontWeight: 400,
    color: TEXT.secondary,
    marginLeft: "2rem",
    wordBreak: "break-all",
  },
  decisionDate: {
    fontSize: "14px",
    fontWeight: 400,
    color: TEXT.secondary,
    marginRight: "2rem",
  },
  decisionTableHeading: {
    fontSize: "1.1rem",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
  },
  hov: {
    "&:hover": {
      color: TEXT.primary,
    },
  },
  alignRight: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    gap: "0.75rem",
  },
  // Label/value row for free text (e.g. reason for reopening): the label stays
  // on one line and the value is clamped to two lines, full text on hover.
  longTextRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "0.5rem",
    gap: "2rem",
  },
  longTextLabel: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  longTextValue: {
    minWidth: 0,
    // Chrome drops the line-clamp "…" on right-aligned text, so align left and
    // push the block right instead — short values still sit flush right.
    marginLeft: "auto",
    textAlign: "left",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    overflowWrap: "anywhere",
    cursor: "default",
  },
  boldText: {
    fontWeight: "600",
  },
  // ---- AI summary styles ----
  // Long cards (AI summary, Stage-wise Trail; Record of Proceedings uses the
  // same cap): the heading stays put and the content scrolls inside the card.
  scrollCard: {
    maxHeight: "90vh",
    overflow: "hidden",
  },
  scrollBody: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowY: "auto",
    paddingRight: "0.5rem",
  },
  summaryTitle: {
    fontSize: "1.05rem",
    color: TEXT.strong,
    marginBottom: "0.5rem",
    fontWeight: 600,
    overflowWrap: "anywhere",
  },
  summarySectionHeading: {
    fontSize: "0.95rem",
    color: TEXT.strong,
    marginTop: "1rem",
    marginBottom: "0.25rem",
    fontWeight: 600,
    overflowWrap: "anywhere",
  },
  summaryBody: {
    fontSize: "0.9rem",
    lineHeight: 1.6,
    color: TEXT.secondary,
    overflowWrap: "anywhere",
  },
  summaryPlaceholder: {
    color: TEXT.muted,
  },
  summaryDate: {
    fontSize: "0.78rem",
    color: TEXT.muted,
    marginTop: "0.25rem",
  },
}));

export async function startCaseSummary(dispute_id) {
  return await instance.post(`/bac/arbitrator/cases/${dispute_id}/summary/generate/`);
}

export async function getCaseSummary(dispute_id) {
  return await instance.get(`/bac/arbitrator/cases/${dispute_id}/summary/`);
}

// Renders inline **bold** segments inside a single line of summary text.
function renderInline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((seg, i) =>
    seg.startsWith("**") && seg.endsWith("**") ? (
      <strong key={i} style={{ color: TEXT.primary, fontWeight: 600 }}>
        {seg.slice(2, -2)}
      </strong>
    ) : (
      <React.Fragment key={i}>{seg}</React.Fragment>
    )
  );
}

// The order sheet toolbar, in TinyMCE's pipe-delimited format. `ordershortcuts`
// and `recordaudio` are supplied as customItems, not built in.
const ORDER_TOOLBAR =
  "undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | table pagebreak newpage | removeformat | ordershortcuts | recordaudio";

// The order start page as sent to the backend: a whole number from 1 to 100000000.
const startPageNumber = (value) =>
  Math.min(100000000, Math.max(1, parseInt(value, 10) || 1));

export default function SingleDisputeRvACCB({
  profile,
  activeDispute,
  activeCase,
  activities,
  allProfiles,
  reload,
  hearingDate,
  disputeId,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { showSnackbar } = useSnackbar();
  const isDisputeClosed = activeDispute?.status === 'closed';
  const isPartyOrCounsel = profile.profile_type !== "arbitrator_rv" && profile.profile_type !== "mediator";
  const [currentView, setCurrentView] = useState("dispute");

  const [activitiesSingle, setActivitiesSingle] = useState([]);
  const [summary, setSummary] = useState('');
  const [summaryGeneratedAt, setSummaryGeneratedAt] = useState('');
  const [summaryStatus, setSummaryStatus] = useState('loading');
  const summaryTimer = useRef(null);
  const summaryPollId = useRef(0);
  const [stageTrail, setStageTrail] = useState([]);
  const [stageTrailLoading, setStageTrailLoading] = useState(true);
  const [stageTrailError, setStageTrailError] = useState('');
  const [scrutinyDocs, setScrutinyDocs] = useState([]);
  const [notices, setNotices] = useState([]);
  const [reuploadingId, setReuploadingId] = useState(null);
  const reuploadFileInputRef = useRef(null);
  const reuploadTargetDocRef = useRef(null);

  const loadScrutinyDocs = () => {
    getCaseScrutinyDocs(activeDispute.id)
      .then((res) => {
        const docs = Array.isArray(res.data) ? res.data?.documents : (res.data?.documents || []);
        setScrutinyDocs(docs);
      })
      .catch((err) => {
        console.error("Error loading case scrutiny documents:", err);
      });
  };

  const fetchTimeline = () => {
    setStageTrailLoading(true);
    getCaseTimeline(activeDispute?.id)
      .then((res) => {
        setStageTrail(res.data);
        setStageTrailLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching timeline:", err);
        setStageTrailLoading(false);
      });
  };

  const readSummary = async () => {
    try {
      const { data } = await getCaseSummary(activeDispute.id);
      setSummary(data.summary || '');
      setSummaryGeneratedAt(data.generated_at || '');
      const status = data.status || (data.summary ? 'done' : 'none');
      setSummaryStatus(status);
      return status;
    } catch (err) {
      if (err?.response?.status === 400) { setSummaryStatus('none'); return 'none'; }
      console.error("Error loading AI summary:", err);
      setSummaryStatus('failed');
      return 'failed';
    }
  };

  const SUMMARY_POLL_MS = 4000;
  const SUMMARY_MAX_POLLS = 60;

  const stopSummaryPolling = () => {
    clearTimeout(summaryTimer.current);
    summaryTimer.current = null;
    summaryPollId.current += 1;
  };

  const pollSummary = () => {
    stopSummaryPolling();
    const myId = summaryPollId.current;
    let n = 0;
    const tick = async () => {
      n += 1;
      const s = await readSummary();
      if (myId !== summaryPollId.current) return;

      if (s !== 'processing') return;
      if (n >= SUMMARY_MAX_POLLS) {
        setSummaryStatus('timed_out');
        return;
      }
      summaryTimer.current = setTimeout(tick, SUMMARY_POLL_MS);
    };
    summaryTimer.current = setTimeout(tick, SUMMARY_POLL_MS);
  };

  const regenerateSummary = async () => {
    setSummaryStatus('processing');
    try {
      await startCaseSummary(activeDispute.id);
      pollSummary();
    } catch (err) {
      console.error("Error starting AI summary:", err);
      setSummaryStatus('failed');
    }
  };

  useEffect(() => {
    if (!activeDispute?.id) return undefined;
    if (profile?.profile_type !== "arbitrator_rv") {
      setSummaryStatus('none');
      return undefined;
    }
    (async () => {
      const s = await readSummary();
      if (s === 'processing') pollSummary();
    })();
    return () => stopSummaryPolling();
  }, [activeDispute?.id, profile?.profile_type]);

  useEffect(() => {
    fetchTimeline();

    loadScrutinyDocs();

    instance.get("/bac/notice/", {
      params: {
        dispute_id: activeDispute.id,
        profile_id: profile.id
      }
    })
      .then((res) => {
        const data = res.data;
        if (data && Array.isArray(data.results)) {
          setNotices(data.results);
        } else if (Array.isArray(data)) {
          setNotices(data);
        } else {
          setNotices([]);
        }
      })
      .catch((err) => {
        console.error("Error loading case notices:", err);
      });
  }, [activeDispute, profile]);

  const handleOpenNotice = async (noticeId) => {
    try {
      const res = await instance.get(`/bac/notice/download/${noticeId}/`);
      const documents = res.data?.documents || [];
      const onError = (message) => showSnackbar(message, "error");
      if (documents.length === 1) {
        navigateToTrustedUrl(documents[0].download_url, {
          onError,
          context: "notice download",
        });
      } else {
        documents.forEach((doc) => {
          downloadTrustedUrlInIframe(doc.download_url, {
            onError,
            context: "notice download",
          });
        });
      }
    } catch (err) {
      console.error("Failed to download notice documents:", err);
    }
  };

  // Open the document itself via a fresh signed preview URL.
  const handleOpenScrutinyDoc = async (scrutinyId) => {
    if (!scrutinyId) return;
    try {
      const res = await getScrutinyDocumentPreview(scrutinyId);
      const url = res?.data?.url;
      if (url) {
        openTrustedUrl(url, {
          context: "scrutiny document preview",
          onError: (message) => showSnackbar(message, "error"),
        });
      }
    } catch (err) {
      console.error("Error opening document:", err);
    }
  };

  const handleScrutinyDocClick = (doc) => {
    if (!doc?.id) return;
    if (doc.has_defect_memo) {
      downloadDefectMemo(doc.id, (msg) => showSnackbar(msg, "error"));
      return;
    }
    handleOpenScrutinyDoc(doc.id);
  };

  // Re-upload a corrected version of a defective scrutiny document.
  const handleReuploadScrutinyDoc = (doc) => {
    reuploadTargetDocRef.current = doc;
    if (reuploadFileInputRef.current) {
      reuploadFileInputRef.current.value = null;
      reuploadFileInputRef.current.click();
    }
  };

  const handleReuploadFileChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    const doc = reuploadTargetDocRef.current;
    if (!file || !doc) return;

    setReuploadingId(doc.id);
    try {
      if (!isDocMgmtAuthenticated()) {
        await authenticateDocMgmt(profile.user.email);
      }
      const uploadRes = await uploadDocMgmtFile(
        file,
        activeDispute.docs_root_folder_id,
        getRequestConfig({ custom_dispute_id: activeDispute.tiac_custom_dispute_id })
      );
      const newId = uploadRes?.data?.id;
      if (doc.docs_file_id) {
        await deleteDocMgmtFile(doc.docs_file_id);
      }
      await reuploadScrutinyDocument(doc.id, { docs_file_id: newId, doc_name: file.name });
      loadScrutinyDocs();
      Swal.fire("Success", "Document re-uploaded successfully.", "success");
    } catch (err) {
      console.error("Error re-uploading scrutiny document:", err);
      Swal.fire("Error", "Failed to re-upload document. Please try again.", "error");
    } finally {
      setReuploadingId(null);
      reuploadTargetDocRef.current = null;
    }
  };

  const [questionRadio, setQuestionRadio] = useState();
  const [answerRadio, setanswerRadio] = useState();
  React.useEffect(() => {
    if (profile.id == activeDispute.created_by) {
      getQuestionsTiac(profile.user.email).then(
        (res) => {
          setQuestionRadio(
            res.data.results.find((item) => item.display_order_id == 51)
          );
        },
        (error) => {
          console.log("err", error);
        }
      );
    }
  }, [activeDispute, profile.id, profile.user.email]);
  React.useEffect(() => {
    if (questionRadio)
      GetAnswersTiac(profile.user.email, activeDispute.id).then((res) => {
        let t = res.data.results.find(
          (item) => item.question == questionRadio.id
        );
        setanswerRadio(t);
      });
  }, [questionRadio, profile, activeDispute]);

  const isRegistrationCompleted = activeDispute.approved;

  const isFormButtonEnabled = activeDispute.created_by == profile.id;
  const isPaymentCompleted =
    activeDispute.rv_tiac_payment_status &&
      activeDispute.rv_tiac_payment_status == "complete"
      ? true
      : false;
  const decisionFiles = activeDispute.all_docs.filter(
    (item) => !item.is_rfa_rv
  );
  const sharedAwards = activeDispute.all_docs.filter(
    (item) => !item.is_rfa_rv && item.is_final
  );
  const sharedPartialAwards = activeDispute.all_docs.filter(
    (item) =>
      !item.is_rfa_rv && item.is_final && item.award_type == "partial_award"
  );
  const sharedFinalAwards = activeDispute.all_docs.find(
    (item) =>
      !item.is_rfa_rv && item.is_final && item.award_type == "final_award"
  );

  const [currentDecision, setCurrentDecision] = useState();
  const [open, setOpen] = useState(false);
  const openModal = () => { setOpen(true); };
  const closeModal = () => { setOpen(false); setCurrentDecision(); };

  const [openAwardType, setOpenAwardType] = useState(false);
  const openModalAwardType = () => { setOpenAwardType(true); };
  const closeModalAwardType = () => {
    setOpenAwardType(false);
    setSelectedAwardType("");
    setAwardInFavourOf("");
    setAwardValue("");
    setApplicableStampDuty("");
    setIsMultiAwardParties(false);
    setAwardError("");
    setCurrentDecision();
  };

  const [openUpload, setOpenUpload] = React.useState(false);
  const [files, setFiles] = React.useState([]);

  const addFile = (file) => {
    files.push(file);
    setFiles(files);
  };
  const deleteFile = (index) => {
    let localFiles = [...files];
    localFiles.splice(index, 1);
    setFiles(localFiles);
  };

  const [loading, setLoading] = useState(false);

  // ── Final award extra details (award-in-favour-of / value / stamp duty) ────
  const [selectedAwardType, setSelectedAwardType] = useState("");
  const [awardParties, setAwardParties] = useState([]);
  const [awardInFavourOf, setAwardInFavourOf] = useState("");
  const [awardValue, setAwardValue] = useState("");
  const [applicableStampDuty, setApplicableStampDuty] = useState("");
  const [submittingAward, setSubmittingAward] = useState(false);
  const [awardError, setAwardError] = useState("");
  const [isMultiAwardParties, setIsMultiAwardParties] = useState(false);

  const [openDraftOrder, setOpenDraftOrder] = useState(false);
  // Full-screen editor; every way of closing the editor drops back to normal.
  const [draftFullscreen, setDraftFullscreen] = useState(false);
  useEffect(() => {
    if (!openDraftOrder) setDraftFullscreen(false);
  }, [openDraftOrder]);
  const editorRef = useRef(null);
  const shortcutListRef = useRef([]);
  const shortcutMapRef = useRef({});

  // Load the typing shortcuts once.
  useEffect(() => {
    let alive = true;
    fetchOrderShortcuts().then((list) => {
      if (!alive) return;
      shortcutListRef.current = list;
      shortcutMapRef.current = buildShortcutMap(list);
    });
    return () => { alive = false; };
  }, []);

  // ── Draft state ──────────────────────────────────────────────────────────
  const [drafts, setDrafts] = useState([]);
  const [draftsLoading, setDraftsLoading] = useState(false);
  const [draftsError, setDraftsError] = useState('');
  // The draft being edited (null = new draft)
  const [editingDraft, setEditingDraft] = useState(null);
  // Number on the first page of the order printout / download; later pages
  // continue from it. Saved on the draft (start_page). Kept as typed text.
  const [startPage, setStartPage] = useState('1');
  const startPageRef = useRef('1');
  startPageRef.current = startPage;
  // Identifies the document the editor is mounted for. Not `editingDraft`:
  // auto-save replaces that with the server's copy on every save, which
  // remounted the editor mid-edit and sent the caret to the end.
  const [editorSession, setEditorSession] = useState(null);
  // The draft as it was when the editor opened, for the same reason.
  const openedDraftRef = useRef(null);

  // "Name draft" dialog — shared by Save and Download actions
  const [draftActionLoading, setDraftActionLoading] = useState(false);
  const [saveDraftStatus, setSaveDraftStatus] = useState(null); // null | 'success' | 'error'
  const [saveDraftMsg, setSaveDraftMsg] = useState('');

  // Seed HTML for a NEW draft: the pre-filled ACCB order sheet from the backend
  // (letterhead + order sheet, locked except the order body).
  const [templateContent, setTemplateContent] = useState('');
  const [templateLoading, setTemplateLoading] = useState(false);
  // The order sheet being edited. The editor is controlled, so the document
  // lives here rather than in the editor's DOM.
  const [orderHtml, setOrderHtml] = useState('');
  const orderHtmlRef = useRef('');
  const orderEditorsRef = useRef({});
  // The editor as last focused, so dictation inserts at the caret rather
  // than always at the end of the order.
  const activeOrderEditorRef = useRef(null);

  const orderDraftsUrl = (suffix = '') =>
    `/bac/arbitrator/cases/${disputeId}/order-drafts/${suffix}`;

  // Document formats (ACCB order sheet + the Centre's shared formats). The
  // picker chooses the format for the NEXT new draft; an existing draft keeps
  // its own format. editorFormatRef is sent with the save body for new drafts.
  const [orderFormats, setOrderFormats] = useState([]);
  const [newOrderFormat, setNewOrderFormat] = useState('all');
  const editorFormatRef = useRef('order_sheet');

  useEffect(() => {
    let alive = true;
    instance
      .get('/bac/arbitrator/order-drafts/formats/')
      .then((res) => { if (alive) setOrderFormats(res.data?.formats || []); })
      .catch((err) => console.error('Failed to load order formats:', err));
    return () => { alive = false; };
  }, []);

  // Fetch drafts when Record Order section mounts / case changes
  const fetchDrafts = async () => {
    setDraftsLoading(true);
    setDraftsError('');
    const token = isLoggedIn();
    try {
      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 401) { history.push('/login'); return; }
      const data = await resp.json();
      setDrafts(Array.isArray(data) ? data : (data.results || []));
    } catch {
      setDraftsError('Failed to load drafts.');
    } finally {
      setDraftsLoading(false);
    }
  };

  useEffect(() => {
    if (profile?.profile_type === "arbitrator_rv") {
      fetchDrafts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disputeId, profile]);

  // Keep the sheet in a ref as well as state: the save, download, proofread and
  // transcription paths all read it synchronously from the editorRef adapter.
  const applyOrderHtml = (html) => {
    orderHtmlRef.current = html || '';
    setOrderHtml(orderHtmlRef.current);
  };

  // Put the caret in the order sheet so typing and dictation land in it.
  const focusOrderRegion = () => {
    const editor = Object.values(orderEditorsRef.current)[0];
    if (editor) editor.commands.focus('end');
    return editor || null;
  };

  // editorRef used to hold the TinyMCE instance. It now holds an adapter with
  // the same four methods the rest of this component calls, so the save,
  // download, proofread and transcription paths are unchanged. getContent()
  // returns the whole sheet exactly as before.
  useEffect(() => {
    editorRef.current = {
      getContent: () => orderHtmlRef.current,
      setContent: (html) => applyOrderHtml(html),
      insertContent: (html) => {
        // Insert where the caret is. Dictation used to be preceded by
        // placeCaretInOrderRegion, which collapsed the selection to the end of the
        // order body, so a transcript always landed at the bottom however the
        // drafter had positioned the cursor. Only fall back to the end when no
        // editor has not been focused yet.
        const editors = Object.values(orderEditorsRef.current);
        const target =
          editors.find((editor) => editor.isFocused) || activeOrderEditorRef.current;
        if (target) {
          target.chain().focus().insertContent(html).run();
          return;
        }
        const fallback = focusOrderRegion();
        if (fallback) fallback.chain().focus('end').insertContent(html).run();
      },
      focusOrderRegion,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load the sheet when the drafting dialog opens, and whenever a different
  // draft is picked. TinyMCE read this once through initialValue; the editors
  // here are controlled, so it goes through state.
  useEffect(() => {
    if (!openDraftOrder) return;
    const opened = openedDraftRef.current;
    applyOrderHtml(opened ? opened.content || '' : templateContent);
    // Deliberately NOT depending on `editingDraft`: auto-save swaps it every
    // minute, and re-pushing that HTML resets the caret. `templateContent`
    // stays, because a new draft's template arrives after the dialog opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDraftOrder, editorSession, templateContent]);

  // The "Post this matter" links, one per page. A click opens the booking page
  // in a new tab (a plain click would navigate away and take the unsaved draft
  // with it); on return, the booking made there fills the clicked link and no
  // other. Backend-built, no local storage.
  const {
    handleLinkClick: handleOrderLinkClick,
    getHref: getPostMatterHref,
    getSignature: getPostMatterSignature,
  } = usePostMatterLinks({
    open: openDraftOrder,
    session: editorSession,
    lineUrl: disputeId ? orderDraftsUrl('post-matter-line/') : null,
    templateUrl:
      disputeId && editorFormatRef.current === 'order_sheet'
        ? orderDraftsUrl('template/?doc_format=order_sheet')
        : null,
    getHtml: () => orderHtmlRef.current,
    setHtml: applyOrderHtml,
  });

  // Download an existing saved draft (GET)
  const handleDownloadDraft = async (draft) => {
    const token = isLoggedIn();
    try {
      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/download/?draft_id=${draft.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 401) { history.push('/login'); return; }
      if (!resp.ok) return;
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${draft.title || 'draft'}.docx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      // silent — could surface a snackbar if desired
    }
  };

  // Open editor with a draft's content
  const handleEditDraft = (draft) => {
    editorFormatRef.current = (draft && draft.format) || 'order_sheet';
    setEditingDraft(draft);
    setStartPage(String((draft && draft.start_page) || 1));
    openedDraftRef.current = draft || null;
    setEditorSession(`draft-${draft.id}`);
    setOpenDraftOrder(true);
  };

  // Open editor for a brand-new draft — seed it with the official ACCB order
  // sheet from the backend so it opens on the template, not a blank page.
  const handleNewDraft = async (formatKey = 'order_sheet') => {
    editorFormatRef.current = formatKey;
    setEditingDraft(null);
    setStartPage('1');
    openedDraftRef.current = null;
    setEditorSession(`new-${Date.now()}`);
    setTemplateContent('');
    setTemplateLoading(true);
    try {
      const res = await instance.get(
        orderDraftsUrl(`template/?doc_format=${encodeURIComponent(formatKey)}`)
      );
      setTemplateContent(res.data?.content || '');
    } catch (err) {
      console.error('Failed to load order template:', err);
    } finally {
      setTemplateLoading(false);
    }
    setOpenDraftOrder(true);
  };

  // Save draft (POST /order-drafts/) — creates or updates
  const executeSave = async (titleToUse) => {
    setDraftActionLoading(true);
    setSaveDraftStatus(null);
    setSaveDraftMsg('');
    const content = editorRef.current ? editorRef.current.getContent() : '';
    const body = {
      title: titleToUse,
      content,
      start_page: startPageNumber(startPage),
    };
    if (editingDraft) body.draft_id = editingDraft.id;
    else body.format = editorFormatRef.current;

    const token = isLoggedIn();
    try {
      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      );
      if (resp.status === 401) { history.push('/login'); return; }
      if (resp.ok) {
        const data = await resp.json();
        if (data.draft) setEditingDraft(data.draft);
        fetchDrafts();
        setSaveDraftStatus('success');
        setSaveDraftMsg('Draft saved successfully.');
      } else {
        const err = await resp.json().catch(() => ({}));
        setSaveDraftStatus('error');
        setSaveDraftMsg(err.error || err.detail || 'Failed to save draft.');
      }
    } catch {
      setSaveDraftStatus('error');
      setSaveDraftMsg('Failed to save draft. Please try again.');
    } finally {
      setDraftActionLoading(false);
    }
  };

  // Download draft (POST /order-drafts/download/)
  const executeDownload = async (titleToUse) => {
    setDraftActionLoading(true);
    setSaveDraftStatus(null);
    setSaveDraftMsg('');
    const content = editorRef.current ? editorRef.current.getContent() : '';
    const token = isLoggedIn();
    try {
      // Save first instead (that endpoint updates in
      // place when it gets a draft_id), then pull the .docx for the saved draft.
      const body = {
        title: titleToUse,
        content,
        start_page: startPageNumber(startPage),
      };
      if (editingDraft) body.draft_id = editingDraft.id;
      else body.format = editorFormatRef.current;
      const saveResp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      );
      if (saveResp.status === 401) { history.push('/login'); return; }
      if (!saveResp.ok) {
        const err = await saveResp.json().catch(() => ({}));
        setSaveDraftStatus('error');
        setSaveDraftMsg(err.error || err.detail || 'Download failed.');
        return;
      }
      const saveData = await saveResp.json().catch(() => ({}));
      const draft = saveData.draft || editingDraft;
      if (!draft?.id) {
        setSaveDraftStatus('error');
        setSaveDraftMsg('Could not prepare the download.');
        return;
      }
      setEditingDraft(draft);

      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/download/?draft_id=${draft.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 401) { history.push('/login'); return; }
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        setSaveDraftStatus('error');
        setSaveDraftMsg(err.error || err.detail || 'Download failed.');
        return;
      }
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${draft.title || titleToUse}.docx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      fetchDrafts();
    } catch {
      setSaveDraftStatus('error');
      setSaveDraftMsg('Download failed. Please try again.');
    } finally {
      setDraftActionLoading(false);
    }
  };

  // Save and Download both run straight away. An existing draft keeps its own
  // title; a new one takes the next name in its sequence (see nextDraftTitle).
  const runDraftAction = (action) => {
    const title =
      editingDraft?.title || nextDraftTitle(drafts, editorFormatRef.current);
    if (action === 'save') executeSave(title);
    else executeDownload(title);
  };

  // ── Auto-save draft ──────────────────────────────────────────────────────
  const editingDraftRef = useRef(editingDraft);
  const draftActionLoadingRef = useRef(draftActionLoading);
  const openDraftOrderRef = useRef(openDraftOrder);
  const draftsRef = useRef(drafts);

  useEffect(() => {
    editingDraftRef.current = editingDraft;
  }, [editingDraft]);

  useEffect(() => {
    draftActionLoadingRef.current = draftActionLoading;
  }, [draftActionLoading]);

  useEffect(() => {
    openDraftOrderRef.current = openDraftOrder;
  }, [openDraftOrder]);

  useEffect(() => {
    draftsRef.current = drafts;
  }, [drafts]);

  const executeAutoSave = useCallback(async () => {
    if (!disputeId || !openDraftOrderRef.current || !editorRef.current || draftActionLoadingRef.current) {
      return;
    }
    if (recorderStateRef.current === "recording" || recorderStateRef.current === "transcribing") {
      return;
    }

    const currentDraft = editingDraftRef.current;
    const titleToUse =
      currentDraft?.title ||
      nextDraftTitle(draftsRef.current, editorFormatRef.current);

    const content = editorRef.current.getContent();
    if (!currentDraft && (!content || content.replace(/<[^>]+>/g, "").trim() === "")) {
      return;
    }

    draftActionLoadingRef.current = true;
    setDraftActionLoading(true);

    const body = {
      title: titleToUse,
      content,
      start_page: startPageNumber(startPageRef.current),
    };
    if (currentDraft?.id) body.draft_id = currentDraft.id;
    else body.format = editorFormatRef.current;

    const token = isLoggedIn();
    try {
      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/order-drafts/`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      );
      if (resp.status === 401) { history.push('/login'); return; }
      if (resp.ok) {
        const data = await resp.json();
        if (data.draft) {
          setEditingDraft(data.draft);
          editingDraftRef.current = data.draft;
        }
        fetchDrafts();
        const timeStr = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        setSaveDraftStatus('success');
        setSaveDraftMsg(`Draft auto-saved at ${timeStr}.`);
      }
    } catch (err) {
      console.error("Auto-save failed:", err);
    } finally {
      draftActionLoadingRef.current = false;
      setDraftActionLoading(false);
    }
  }, [disputeId, fetchDrafts, history]);

  // Auto-save the draft every 1 minute (60,000 ms) while editor is open
  useEffect(() => {
    if (!openDraftOrder) return;

    const intervalId = setInterval(() => {
      executeAutoSave();
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, [openDraftOrder, executeAutoSave]);

  // ── Book Hearing Room ────────────────────────────────────────────────────
  const [openBookHearing, setOpenBookHearing] = useState(false);
  // Prefill from an Order Drafting "Post this matter" link:
  // /disputes/<id>?book_order_drafting=true&date=…&stage=…
  const [bookHearingPrefill, setBookHearingPrefill] = useState(null);

  const closeBookHearing = () => {
    setOpenBookHearing(false);
  };

  // Deep link: open the Book Hearing Room modal pre-filled when the URL carries
  // the order-drafting params.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("book_order_drafting") === "true") {
      setBookHearingPrefill({
        date: params.get("date") || "",
        stage: params.get("stage") || "",
      });
      setOpenBookHearing(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Proofread ────────────────────────────────────────────────────────────
  const [proofreadState, setProofreadState] = useState('idle');
  const [proofreadMessage, setProofreadMessage] = useState('');

  const handleProofread = async () => {
    if (!editorRef.current) return;
    const html = editorRef.current.getContent();
    const plain = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

    if (plain.length < 20) {
      setProofreadState('error');
      setProofreadMessage('Editor content is too short to review (minimum 20 characters).');
      return;
    }

    setProofreadState('loading');
    setProofreadMessage('');

    const token = isLoggedIn();
    try {
      const resp = await fetch(
        `${baseUrl}bac/arbitrator/cases/${disputeId}/review-text/`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ text: plain }),
        }
      );

      if (resp.status === 401) { history.push('/login'); return; }
      if (resp.status === 403) {
        setProofreadState('error');
        setProofreadMessage('You do not have access to this case.');
        return;
      }

      const data = await resp.json();

      if (!resp.ok) {
        setProofreadState('error');
        setProofreadMessage(data.error || 'AI service unavailable, please try again.');
        return;
      }

      const suggestions = data.suggestions || [];
      let content = editorRef.current.getContent();
      let applied = 0;
      for (const s of suggestions) {
        if (s.original && s.suggestion && content.includes(s.original)) {
          content = content.replace(s.original, s.suggestion);
          applied += 1;
        }
      }
      editorRef.current.setContent(content);
      setProofreadState('done');
      setProofreadMessage(`Done — ${applied} correction${applied !== 1 ? 's' : ''} applied.`);
    } catch {
      setProofreadState('error');
      setProofreadMessage('AI service unavailable, please try again.');
    }
  };

  // ── Audio recorder ───────────────────────────────────────────────────────
  const recorderStateRef = useRef('idle');
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const [recorderUiState, setRecorderUiState] = useState('idle');
  const [transcribeError, setTranscribeError] = useState('');

  const setRecState = (s) => {
    recorderStateRef.current = s;
    setRecorderUiState(s);
  };

  const handleMicClick = useRef(null);
  handleMicClick.current = async (editor) => {
    if (recorderStateRef.current === 'transcribing') return;

    if (recorderStateRef.current === 'idle') {
      setTranscribeError('');
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        chunksRef.current = [];
        const mimeType = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '';
        const mr = new MediaRecorder(stream, mimeType ? { mimeType } : {});

        mr.ondataavailable = (e) => {
          if (e.data.size > 0) chunksRef.current.push(e.data);
        };

        mr.onstop = async () => {
          stream.getTracks().forEach((t) => t.stop());
          setRecState('transcribing');

          const blob = new Blob(chunksRef.current, { type: mr.mimeType || 'audio/webm' });
          const formData = new FormData();
          formData.append('audio_file', blob, 'recording.webm');
          formData.append('language', 'en');

          const token = isLoggedIn();
          try {
            const resp = await fetch(
              `${baseUrl}bac/arbitrator/cases/${activeDispute.id}/transcribe/`,
              {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
              }
            );

            if (resp.status === 401) { history.push('/login'); return; }

            if (!resp.ok) {
              const errData = await resp.json().catch(() => ({}));
              setTranscribeError(
                resp.status === 400
                  ? errData.detail || errData.error || 'Invalid request. Please try again.'
                  : 'AI service unavailable, please try again.'
              );
            } else {
              const data = await resp.json();
              editorRef.current.insertContent(data.transcript || '');
              // The endpoint returns the case's future listings alongside the
              // transcript. Append them so the order records what is already
              // scheduled — the admin Order Drafting screen does the same, from
              // the same shared helper.
              const hearingsHtml = buildHearingDatesHtml(data.upcoming_hearings);
              if (hearingsHtml) editorRef.current.insertContent(hearingsHtml);
            }
          } catch {
            setTranscribeError('AI service unavailable, please try again.');
          } finally {
            setRecState('idle');
          }
        };

        mr.start();
        mediaRecorderRef.current = mr;
        setRecState('recording');
      } catch {
        setTranscribeError('Microphone access denied. Please allow microphone permissions.');
      }
    } else if (recorderStateRef.current === 'recording') {
      mediaRecorderRef.current.stop();
    }
  };

  // Typing shortcuts are an input rule on the editor. The map is read
  // through a getter so the editors can mount before the list has loaded.
  // Case number for the printout's running header (page 2 onward).
  const caseNumberRef = useRef("");
  caseNumberRef.current = activeDispute
    ? activeDispute.tiac_custom_dispute_id || ""
    : "";

  const orderPreset = useMemo(
    () => (options) => [
      ...documentPreset(options),
      createShortcutExpansion(() => shortcutMapRef.current),
      // Every page the arbitrator adds gets its own "Post this matter" link.
      PostMatterLinks.configure({
        getHref: getPostMatterHref,
        getSignature: getPostMatterSignature,
        isOrderSheet: () => editorFormatRef.current === 'order_sheet',
      }),
    ],
    [getPostMatterHref, getPostMatterSignature]
  );

  // recordaudio and ordershortcuts, as React toolbar items. The TinyMCE
  // versions needed micBtnApiRef to push state into the button imperatively;
  // here the button reads recorderUiState directly.
  const orderToolbarItems = useMemo(
    () => ({
      // Page break / New page, kept in the order table.
      ...ORDER_PAGE_ITEMS,
      recordaudio: {
        title: 'Record audio - click to start, click again to stop & transcribe',
        icon: <MicIcon fontSize="small" />,
        active: () => recorderUiState === 'recording',
        disabled: () => recorderUiState === 'transcribing',
        run: (editor) => {
          if (handleMicClick.current) handleMicClick.current(editor);
        },
      },
      ordershortcuts: {
        title: 'Typing shortcuts',
        render: () => <ShortcutsButton getList={() => shortcutListRef.current} />,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [recorderUiState]
  );


  const uploadAward = async (type, extraFields = {}) => {
    const data = new FormData();
    data.append("award_file", files[0]);
    data.append("award_type", type);
    Object.keys(extraFields).forEach((key) => {
      if (extraFields[key] !== undefined && extraFields[key] !== null) {
        if (key === "award_in_favour_of" && Array.isArray(extraFields[key])) {
          extraFields[key].forEach((val) => {
            data.append("award_in_favour_of", val);
          });
        } else {
          data.append(key, extraFields[key]);
        }
      }
    });
    await instance.post(
      "/bac/arbitrator/cases/" + activeDispute.id + "/award/",
      data,
      { headers: { "content-type": "multipart/form-data" } }
    );
  };

  const handleAwardTypeChange = (e) => {
    const val = e.target.value;
    setSelectedAwardType(val);
    if (val === "final_award") {
      instance
        .get("/bac/cases/" + activeDispute.id + "/award-parties/")
        .then((res) => {
          setAwardParties(res?.data?.parties || []);
          const isMulti = res?.data?.multiple_parties || false;
          setIsMultiAwardParties(isMulti);
          setAwardInFavourOf(isMulti ? [] : "");
        })
        .catch((error) => {
          console.log(error);
          setAwardParties([]);
          setIsMultiAwardParties(false);
          setAwardInFavourOf("");
        });
    }
  };

  const handleAwardSubmit = () => {
    if (!selectedAwardType) return;

    setAwardError("");

    if (selectedAwardType === "final_award") {
      const favorOf = Array.isArray(awardInFavourOf)
        ? awardInFavourOf
        : (awardInFavourOf ? [awardInFavourOf] : []);
      if (favorOf.length === 0 || (favorOf.length === 1 && !favorOf[0]?.trim())) {
        setAwardError("Please select whom the Award is in Favour of.");
        return;
      }
      if (awardValue === undefined || awardValue === null || awardValue === "") {
        setAwardError("Please enter the Award Value.");
        return;
      }
      if (applicableStampDuty === undefined || applicableStampDuty === null || applicableStampDuty === "") {
        setAwardError("Please enter the Applicable Stamp Duty.");
        return;
      }
    }

    setSubmittingAward(true);

    if (selectedAwardType === "final_award") {
      const favorOf = Array.isArray(awardInFavourOf)
        ? awardInFavourOf
        : (awardInFavourOf ? [awardInFavourOf] : []);
      uploadAward("final_award", {
        award_in_favour_of: favorOf,
        award_value: awardValue,
        applicable_stamp_duty: applicableStampDuty,
        docs_arb_final_order_folder_id: activeDispute.docs_arb_final_order_folder_id,
      })
        .then(() => {
          reload();
          setSubmittingAward(false);
          closeModalAwardType();
        })
        .catch((error) => {
          console.log(error);
          setSubmittingAward(false);
        });
    } else {
      uploadAward("partial_award", { docs_arb_interim_order_folder_id: activeDispute.docs_arb_interim_order_folder_id })
        .then(() => {
          reload();
          setSubmittingAward(false);
          closeModalAwardType();
        })
        .catch((error) => {
          console.log(error);
          setSubmittingAward(false);
        });
    }
  };

  async function deleteDecisionId(id) {
    return await instance.delete(`/arbitrator_decisiondelete/${id}`);
  }

  const deleteDecision = () => {
    deleteDecisionId(currentDecision.id).then(() => { reload(); });
  };

  // ── Sub-components ───────────────────────────────────────────────────────

  function PartiesInvolved() {
    return (
      <Paper
        className={classes.paperPartiesInvolved}
        style={{ padding: "2rem", border: "1px solid #E5E5E5" }}
      >
        <Typography className={classes.PartiesInvolvedHeading}>
          Parties involved
        </Typography>
        {allProfiles.map((profile) => (
          <React.Fragment key={profile.profile.id}>
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Typography className={classes.boldText}>
                  {profile.user.first_name} {profile.user.last_name}
                </Typography>
                {["Claimant", "Respondent", "Defendant"].includes(profile.profile.profile_type) &&
                  getPartyOrganisation(profile.profile).isOrganisation && (
                    <Typography style={{ color: TEXT.secondary, fontSize: "0.85rem", lineHeight: "normal", marginBottom: 2, overflowWrap: "anywhere" }}>
                      Organisation
                      {getPartyOrganisation(profile.profile).representative &&
                        ` · Representative: ${getPartyOrganisation(profile.profile).representative}`}
                    </Typography>
                  )}
                <Typography style={{ color: TEXT.secondary, fontSize: "0.9rem", lineHeight: "normal" }}>
                  {profile.profile.profile_type === "Arbitrator" ||
                    profile.profile.profile_type === "Conciliator"
                    ? "---"
                    : displayEmail(profile.user.email)}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                <Typography>{profile.profile.profile_type}</Typography>
              </Grid>
            </Grid>
            <Box height="0.8rem" />
          </React.Fragment>
        ))}
      </Paper>
    );
  }

  function DisputeDetails() {
    return (
      <Paper className={classes.paperDisputeDetails}>
        <Typography className={classes.disputeNameHeading}>
          {activeDispute.name}
        </Typography>
        <Box height="1.2rem" />
        <Typography className={classes.alignRight}>
          <span>Case ID</span>
          <span>{activeDispute.tiac_custom_dispute_id}</span>
        </Typography>
        <Typography className={classes.alignRight}>
          <span>Category</span>
          {/* Stored lowercase ("cmp", "institutional", "other") — CMP is an
              acronym, the rest read as words. */}
          <span
            style={{
              textTransform:
                String(activeDispute.customer_type || "").toLowerCase().trim() === "cmp"
                  ? "uppercase"
                  : "capitalize",
            }}
          >
            {activeDispute.customer_type}
          </span>
        </Typography>
        {(() => {
          const category = String(activeDispute.customer_type || "").toLowerCase().trim();
          const cleanTicketNumber = String(activeDispute.request_ticket_number || "").replace(/[\\"]/g, "").trim();
          if (category === "cmp") {
            return (
              <Typography className={classes.alignRight}>
                <span>CMP Number</span>
                <span>{cleanTicketNumber || "—"}</span>
              </Typography>
            );
          }
          if (category === "reference") {
            return (
              <>
                <Typography className={classes.alignRight}>
                  <span>MSEFC Number</span>
                  <span>{cleanTicketNumber || "—"}</span>
                </Typography>
                {/* The district whose MSEFC council referred the case, captured
                    at registration and stored in Dispute.region. */}
                <Typography className={classes.alignRight}>
                  <span>Referred From</span>
                  <span>{String(activeDispute.region || "").trim() || "—"}</span>
                </Typography>
              </>
            );
          }
          return null;
        })()}
        <Typography className={classes.alignRight}>
          <span>Registration Date</span>
          <span>{safeDateFormat(activeDispute.created)}</span>
        </Typography>
        {isCaseReopened(activeDispute) && (
          <>
            <Typography className={classes.alignRight}>
              <span>Status</span>
              <span style={{ color: TEXT.brand, fontWeight: 600 }}>Reopened</span>
            </Typography>
            {activeDispute.reopen_date && (
              <Typography className={classes.alignRight}>
                <span>Reopened On</span>
                <span>{safeDateFormat(activeDispute.reopen_date)}</span>
              </Typography>
            )}
            {activeDispute.reopen_reason && (
              <Typography component="div" className={classes.longTextRow}>
                <span className={classes.longTextLabel}>Reason for Reopening</span>
                <Tooltip title={activeDispute.reopen_reason} placement="top-end">
                  <span className={classes.longTextValue}>
                    {activeDispute.reopen_reason}
                  </span>
                </Tooltip>
              </Typography>
            )}
          </>
        )}
        <Typography className={classes.alignRight}>
          <span>Stage</span>
          <span>{activeDispute.current_stage || "-"}</span>
        </Typography>
        <Typography className={classes.alignRight}>
          <span>Next Hearing Date</span>
          <span>{safeDateFormat(activeDispute?.next_hearing_date)}</span>
        </Typography>
        <Typography className={classes.alignRight}>
          <span style={{ fontWeight: 600 }}>Order/Award</span>
        </Typography>
        {sharedPartialAwards.length === 0 && !sharedFinalAwards ? (
          <Typography className={classes.alignRight}>
            <span style={{ color: TEXT.muted, fontStyle: 'italic' }}>No Order/Award shared</span>
            <span>---</span>
          </Typography>
        ) : (
          <>
            {sharedPartialAwards.map((award, index) => (
              <Typography className={classes.alignRight} key={award.id}>
                <span
                  style={{ textDecoration: "underline", cursor: "pointer", color: "blue" }}
                  onClick={() => { downloadLegalDoc(award.id); }}
                >
                  Interim Award {index + 1}
                </span>
                <span>{safeDateFormat(award?.shared_date)}</span>
              </Typography>
            ))}
            {sharedFinalAwards && (
              <Typography className={classes.alignRight}>
                <span
                  style={{ textDecoration: "underline", cursor: "pointer", color: "blue" }}
                  onClick={() => { downloadLegalDoc(sharedFinalAwards.id); }}
                >
                  Final Award
                </span>
                <span>{safeDateFormat(sharedFinalAwards?.shared_date)}</span>
              </Typography>
            )}
          </>
        )}
        {scrutinyDocs.length > 0 && (
          <>
            <Box height="0.8rem" />
            <Typography className={classes.alignRight}>
              <span style={{ fontWeight: 600 }}>Scrutiny</span>
            </Typography>
            {scrutinyDocs.map((doc, idx) => {
              const docName = doc.doc_name || doc.name || "—";
              const docDate = doc.uploaded_at || doc.scrutiny_date || doc.created;
              const isDefective = String(doc.status || "").toLowerCase() === "defective";
              const isReuploading = reuploadingId === doc.id;
              return (
                <Typography className={classes.alignRight} key={doc.id || idx}>
                  <span
                    onClick={() => handleScrutinyDocClick(doc)}
                    title={doc.has_defect_memo ? "Download defect memo" : "Open document"}
                    style={{
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                      minWidth: 0,
                      wordBreak: "break-all",
                    }}
                  >
                    {docName}
                  </span>
                  <span style={{ display: "flex", gap: "0.9rem", alignItems: "center", flexShrink: 0 }}>
                    {isDefective && isPartyOrCounsel && (
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        disabled={isReuploading}
                        onClick={() => handleReuploadScrutinyDoc(doc)}
                        style={{
                          textTransform: "none",
                          minWidth: "auto",
                          padding: "0 0.6rem",
                          // color: isReuploading ? undefined : "#2e7d32",
                          // borderColor: isReuploading ? undefined : "#2e7d32",
                        }}
                      >
                        {isReuploading ? "Re-uploading…" : "Re-upload"}
                      </Button>
                    )}
                    <span>{docDate ? safeDateFormat(docDate) : "—"}</span>
                  </span>
                </Typography>
              );
            })}
          </>
        )}

        {/* Notices Section */}
        <Box height="0.8rem" />
        <Typography className={classes.alignRight}>
          <span style={{ fontWeight: 600 }}>Notices</span>
        </Typography>
        {notices.length === 0 ? (
          <Typography className={classes.alignRight}>
            <span style={{ color: TEXT.muted, fontStyle: 'italic' }}>No notices shared</span>
            <span>---</span>
          </Typography>
        ) : (
          notices.map((notice, idx) => (
            <Typography className={classes.alignRight} key={notice.id || idx}>
              <span
                style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                onClick={() => handleOpenNotice(notice.id)}
              >
                Notice {idx + 1}
              </span>
              <span>{notice.created_at ? safeDateFormat(notice.created_at) : "—"}</span>
            </Typography>
          ))
        )}
        <Box minHeight={"2rem"} flex={1} />
        <Grid container spacing={2}>
          <Grid item xs>
            <Button
              variant="outlined"
              color="primary"
              style={{ width: "100%" }}
              onClick={() => { history.push(`/disputes/${activeDispute.id}/files/0`); }}
            >
              Files
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              variant="outlined"
              color="primary"
              style={{ width: "100%", whiteSpace: "nowrap" }}
              onClick={() => { setCurrentView("directions"); }}
            >
              Directions by Tribunal
            </Button>
          </Grid>
        </Grid>
        <Box height="1rem" />
        {(profile.profile_type == "arbitrator_rv") && (
          <Grid container direction="row" spacing={2}>
            <Grid item xs>
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                onClick={() => setOpenBookHearing(true)}
              >
                <Typography className={classes.boldText} style={{ textTransform: "none" }}>
                  Book Hearing Room
                </Typography>
              </Button>
            </Grid>
          </Grid>
        )}
      </Paper>
    );
  }

  function AISummary() {
    const renderSummary = () => {
      if (summaryStatus === 'loading' || summaryStatus === 'processing') {
        return (
          <Box display="flex" alignItems="center" style={{ gap: "0.6rem" }}>
            <CircularProgress size={18} />
            <Typography className={classes.summaryPlaceholder}>
              {summaryStatus === 'processing' ? 'Generation in progress…' : 'Loading…'}
            </Typography>
          </Box>
        );
      }

      if (summaryStatus === 'timed_out') {
        return (
          <Typography className={classes.summaryPlaceholder}>
            Generation is taking longer than expected. Please try again.
          </Typography>
        );
      }

      if (summaryStatus === 'none') {
        return (
          <Typography className={classes.summaryPlaceholder}>
            {profile?.profile_type === "arbitrator_rv"
              ? "No summary generated yet. Click Generate to create one."
              : "No summary generated yet."}
          </Typography>
        );
      }

      if (summaryStatus === 'failed' && !summary) {
        return (
          <Typography className={classes.summaryPlaceholder}>
            AI service is unavailable right now. Please try again.
          </Typography>
        );
      }

      if (!summary) {
        return (
          <Typography className={classes.summaryPlaceholder}>
            Summary not available
          </Typography>
        );
      }

      let firstHeadingSeen = false;

      return summary.split("\n").map((rawLine, idx) => {
        const line = rawLine.trim();
        if (!line) return null;

        const isHeading =
          line.startsWith("**") &&
          line.endsWith("**") &&
          line.slice(2, -2).indexOf("**") === -1;

        if (isHeading) {
          const text = line.slice(2, -2).replace(/:$/, "");
          if (!firstHeadingSeen) {
            firstHeadingSeen = true;
            return (
              <Typography key={idx} className={classes.summaryTitle}>
                {text}
              </Typography>
            );
          }
          return (
            <Typography key={idx} className={classes.summarySectionHeading}>
              {text}
            </Typography>
          );
        }

        return (
          <Typography key={idx} className={classes.summaryBody}>
            {renderInline(line)}
          </Typography>
        );
      });
    };

    return (
      <Paper className={`${classes.paperDisputeDetails} ${classes.scrollCard}`}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexShrink={0}>
          <Typography className={classes.disputeNameHeading}>
            AI generated summary
          </Typography>
          {profile?.profile_type === "arbitrator_rv" && summaryStatus !== 'loading' && (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              disabled={summaryStatus === 'processing'}
              onClick={regenerateSummary}
            >
              {summaryStatus === 'none' ? 'Generate' : 'Regenerate'}
            </Button>
          )}
        </Box>
        {summaryGeneratedAt && (
          <Typography className={classes.summaryDate}>
            Last generated on: {summaryGeneratedAt}
          </Typography>
        )}
        <Box height="1.2rem" flexShrink={0} />
        <Box className={classes.scrollBody}>{renderSummary()}</Box>
      </Paper>
    );
  }

  // ── Record Order (redesigned) ────────────────────────────────────────────
  function RecordOrder() {
    // The picker doubles as a filter on the drafts list ("all" = every format);
    // New Draft then defaults to the ACCB order sheet.
    const newDraftFormat = newOrderFormat === 'all' ? 'order_sheet' : newOrderFormat;
    // One draft per format per case: once that format has a draft, it is edited
    // from the table instead, so New Draft is hidden (also while drafts load).
    // Depositions of PW2 / RW2 are the exception: one draft per witness.
    const canCreateDraft =
      !draftsLoading &&
      (allowsMultipleDrafts(newDraftFormat) ||
        !drafts.some((d) => (d.format || 'order_sheet') === newDraftFormat));
    const visibleDrafts = newOrderFormat === 'all'
      ? drafts
      : drafts.filter((d) => (d.format || 'order_sheet') === newOrderFormat);
    return (
      <Paper className={classes.paperDisputeDetails}>
        {/* Header row */}
        <Box style={{ marginBottom: "1.2rem" }}>
          <Typography className={classes.disputeNameHeading}>
            Record Order
          </Typography>
          {/* The picker may shrink so the button keeps one line and stays
              inside the card on a phone. */}
          <Box display="flex" justifyContent="flex-end" alignItems="stretch" style={{ marginTop: "0.5rem", gap: "0.5rem" }}>
            <Select
              variant="outlined"
              margin="dense"
              value={newOrderFormat}
              onChange={(e) => setNewOrderFormat(e.target.value)}
              style={{ flex: "0 1 240px", minWidth: 0, background: "#fff", fontSize: "0.8rem" }}
            >
              <MenuItem value="all" style={{ fontSize: "0.8rem" }}>All Formats</MenuItem>
              {(orderFormats.length
                ? orderFormats
                : [{ key: "order_sheet", label: "ACCB Order Sheet" }]
              ).map((f) => (
                <MenuItem key={f.key} value={f.key} style={{ fontSize: "0.8rem" }}>
                  {f.label}
                </MenuItem>
              ))}
            </Select>
            {canCreateDraft && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => handleNewDraft(newDraftFormat)}
                style={{ textTransform: "none", fontSize: "0.8rem", padding: "4px 12px", flexShrink: 0, whiteSpace: "nowrap" }}
              >
                {allowsMultipleDrafts(newDraftFormat)
                  ? `+ New ${nextDraftTitle(drafts, newDraftFormat)}`
                  : "+ New Draft"}
              </Button>
            )}
          </Box>
        </Box>

        {/* Drafts table */}
        {draftsLoading ? (
          <Box display="flex" alignItems="center" style={{ gap: "0.5rem" }}>
            <CircularProgress size={16} />
            <Typography style={{ fontSize: "0.85rem", color: TEXT.muted }}>
              Loading drafts…
            </Typography>
          </Box>
        ) : draftsError ? (
          <Typography style={{ fontSize: "0.85rem", color: TEXT.error }}>
            {draftsError}
          </Typography>
        ) : visibleDrafts.length === 0 ? (
          <Typography style={{ fontSize: "0.85rem", color: TEXT.muted }}>
            {newOrderFormat === 'all'
              ? 'No drafts yet. Click "+ New Draft" to create one.'
              : 'No drafts in this format yet. Click "+ New Draft" to create one.'}
          </Typography>
        ) : (
          <OrderDraftsTable
            drafts={visibleDrafts}
            formats={orderFormats}
            onDownload={handleDownloadDraft}
            onEdit={handleEditDraft}
          />
        )}
      </Paper>
    );
  }

  // ── Render files helper ──────────────────────────────────────────────────
  const renderFiles = (files, deleteFile) => {
    return files.length !== 0
      ? files.map((file, index) => (
        <Box key={index} textAlign="center" position="relative">
          <Box>
            <Typography style={{ wordBreak: "break-all", paddingTop: "20px" }} variant="subtitle2">
              {file.name}
            </Typography>
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={() => { deleteFile(index); }}
            >
              <DeleteOutlineIcon />
            </IconButton>
          </Box>
        </Box>
      ))
      : null;
  };

  // ── Share award function ──────────────────────────────────────────────────
  const shareDecision = (id) => {
    return async () => {
      try {
        const response = await instance.put(
          "/tiacfinaldecession/" + id + "/?host=" + getRealhost(),
          { dispute_id: activeDispute?.id },
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        );
        if (response?.status === 200) {
          reload();
        }

      } catch (error) {
        console.log(error);
      }
    };
  };

  // ── Stage-wise Trail ────────────────────────────────────────────
  function StagewiseTrail() {
    return (
      <Paper className={`${classes.paperDisputeDetails} ${classes.scrollCard}`}>
        <Box style={{ marginBottom: "1.2rem" }} flexShrink={0}>
          <Typography className={classes.disputeNameHeading}>
            Stage-wise Trail
          </Typography>
        </Box>

        <Box className={classes.scrollBody}>
        {stageTrailLoading ? (
          <Box display="flex" alignItems="center" style={{ gap: "0.5rem" }}>
            <CircularProgress size={16} />
            <Typography style={{ fontSize: "0.85rem", color: TEXT.muted }}>
              Loading trail…
            </Typography>
          </Box>
        ) : stageTrailError ? (
          <Typography style={{ fontSize: "0.85rem", color: TEXT.error }}>
            {stageTrailError}
          </Typography>
        ) : stageTrail.length === 0 ? (
          <Typography style={{ fontSize: "0.85rem", color: TEXT.muted }}>
            No progress yet.
          </Typography>
        ) : (
          <ShowProgress
            activeDispute={activeDispute}
            timeLines={stageTrail}
            profile={profile}
            onOpenDirections={() => setCurrentView("directions")}
          />

        )}
        </Box>
      </Paper>
    );
  }

  // ── Main render ──────────────────────────────────────────────────────────
  return (
    <Grid container justify="center">
      <Grid item lg={10} md={10} sm={11} xs={11} className={classes.root}>
        <Button
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          style={{ backgroundColor: "transparent", cursor: "default" }}
        >
          <Grid container spacing={1}>
            <Grid item>
              <Typography
                className={classes.btntext}
                style={{ color: "black" }}
                onClick={() => { history.goBack(); }}
              >
                <KeyboardBackspace />
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                className={`${classes.btntext} ${classes.hov}`}
                style={{ cursor: "pointer" }}
                onClick={() => { history.push("/"); }}
              >
                Dashboard
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.btntext} style={{ color: "black" }}>
                /
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                className={`${classes.btntext} ${classes.hov}`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (currentView !== "dispute") {
                    setCurrentView("dispute");
                    fetchTimeline();
                  } else {
                    history.push(`/disputes/${activeDispute.id}/`);
                  }
                }}
              >
                {activeDispute.name}
              </Typography>
            </Grid>
            {currentView !== "dispute" && (
              <>
                <Grid item>
                  <Typography className={classes.btntext} style={{ color: "black" }}>
                    /
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.btntext} style={{ color: "black" }}>
                    {currentView === "directions"
                      ? "Directions by Tribunal"
                      : "Adjournment Requests"}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </Button>

        <Box height="1rem" />
        <MandateClock mandate={activeDispute?.mandate} closureReason={activeDispute?.reason_for_closure} />
        {profile.profile_type !== "arbitrator_rv" && profile.profile_type !== "mediator" && (
          <Box mb={2}>
            <PartyPendingPayments disputeId={disputeId} />
          </Box>
        )}
        <Box height="1rem" />

        {currentView === "directions" ? (
          <RecordOfDirections
            disputeId={disputeId}
            profile={profile}
            allProfiles={allProfiles}
            onBack={() => {
              setCurrentView("dispute");
              fetchTimeline();
            }}
          />
        ) : currentView === "adjournments" ? (
          <AdjournmentRequests
            disputeId={disputeId}
            allProfiles={allProfiles}
            onBack={() => setCurrentView("dispute")}
          />
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                <DisputeDetails />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                <PartiesInvolved />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                <Adjournments
                  disputeId={disputeId}
                  profile={profile}
                  allProfiles={allProfiles}
                  onOpenPrevious={() => setCurrentView("adjournments")}
                />
              </Grid>
              {profile.profile_type !== "arbitrator_rv" && (
                <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                  <StagewiseTrail />
                </Grid>
              )}
              {(profile.profile_type == "arbitrator_rv") && (
                <>
                  <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                    <AISummary />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                    <RecordOfProceedings disputeId={disputeId} />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                    <StagewiseTrail />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12} style={{ display: "flex" }}>
                    <RecordOrder />
                  </Grid>
                </>
              )}
            </Grid>

            <Box height="4rem" />

            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {(profile.profile_type == "arbitrator_rv" || profile.profile_type == "mediator") && (
                  <>
                    <Typography style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                      Award
                    </Typography>
                    <Box style={{ padding: "1rem" }}>
                      <Grid container spacing={2}>
                        <Grid item sm={6} xs={4}>
                          <Typography className={classes.decisionTableHeading}>Document Name</Typography>
                        </Grid>
                        <Grid item sm={2} xs={3}>
                          <Typography className={classes.decisionTableHeading}>Type</Typography>
                        </Grid>
                        <Grid item sm={2} xs={3}>
                          <Typography className={classes.decisionTableHeading}>Upload Date</Typography>
                        </Grid>
                        <Grid item sm={1} xs={1}></Grid>
                        <Grid item sm={1} xs={1}></Grid>
                      </Grid>
                    </Box>
                    <Paper container style={{ background: "white", border: "1px solid #E5E5E5" }}>
                      {decisionFiles.map((decision) => (
                        <Box
                          key={decision.id}
                          style={{ padding: "8px 1rem", borderBottom: "1px solid #E5E5E5" }}
                        >
                          <Grid container spacing={2} alignItems="center">
                            <Grid item sm={6} xs={4}>
                              <Typography
                                style={{ cursor: "pointer", wordBreak: "break-word", overflowWrap: "anywhere" }}
                                onClick={() => { downloadLegalDoc(decision.id); }}
                              >
                                {decision.name}
                              </Typography>
                            </Grid>
                            <Grid item sm={2} xs={3}>
                              <Typography>
                                {decision.award_type == "partial_award" ? "Interim" : "Final"}
                              </Typography>
                            </Grid>
                            <Grid item sm={2} xs={3}>
                              <Typography>{safeDateFormat(decision.created)}</Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}>
                              {decision.is_final ? (
                                <Typography>
                                  Shared
                                </Typography>
                              ) : (
                                <Button
                                  style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto" }}
                                  onClick={() => {
                                    dispatch(shareDecision(decision.id));
                                  }}
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                >
                                  Share
                                </Button>
                              )}
                            </Grid>
                            <Grid item sm={1} xs={1} style={{ textAlign: 'center' }}>
                              <Delete
                                style={{ cursor: "pointer", color: TEXT.secondary }}
                                onClick={() => { setCurrentDecision(decision); openModal(); }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                      {files.length === 0 && activeDispute.status != "closed" && (
                        <Grid container justify="center">
                          <Grid item>
                            <IconButton
                              style={{ padding: "1rem" }}
                              color="primary"
                              onClick={() => { setOpenUpload(true); }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      )}
                      {renderFiles(files, deleteFile)}
                    </Paper>
                    <Box height="1rem" />
                    <Grid container justify="center">
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ width: "224px" }}
                          onClick={openModalAwardType}
                          disabled={files.length < 1 || loading || activeDispute.status == "closed"}
                        >
                          SUBMIT
                        </Button>
                      </Grid>
                    </Grid>
                    <Box height="2rem" />
                  </>
                )}

                <GeneralActivitiesACCB
                  activities={activitiesSingle}
                  setActivities={setActivitiesSingle}
                  isGetActivityByTabAndId={true}
                  disputeId={disputeId}
                  activityTitle="Case Activity"
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>

      {/* ── Hidden file input for Scrutiny re-upload ── */}
      <input
        type="file"
        ref={reuploadFileInputRef}
        style={{ display: "none" }}
        onChange={handleReuploadFileChange}
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
      />

      {/* ── Upload award dialog ── */}
      <DropzoneDialog
        cancelButtonText="cancel"
        submitButtonText="submit"
        maxFileSize={104857600}
        open={openUpload}
        onClose={() => setOpenUpload(false)}
        onSave={(files) => {
          files.forEach((file) => { addFile(file); });
          setOpenUpload(false);
        }}
        showPreviews={true}
        filesLimit={1}
        showFileNamesInPreview={true}
        previewGridProps={{
          container: { spacing: 1 },
          item: { xs: 12 },
        }}
        previewGridClasses={{ item: classes.dropzonePreviewItem }}
        acceptedFiles={[
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/msword",
          "application/pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ]}
      />

      {/* ── Delete award confirmation ── */}
      <Popup
        open={open}
        closeOnDocumentClick
        closeOnEscape
        onClose={closeModal}
        position="center"
        modal
        nested
        contentStyle={{ background: "white", width: "330px", height: "185px" }}
        overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
      >
        <Box style={{ padding: "1rem 1.3rem" }}>
          <Typography style={{ fontSize: "20px", color: TEXT.primary, fontWeight: "bold", lineHeight: "23px", letterSpacing: "0.0015em" }}>
            Delete Award?
          </Typography>
          <Box height="0.5rem" />
          <Typography style={{ fontSize: "16px", color: TEXT.muted, lineHeight: "28px" }}>
            Are you sure you want to delete this Award?
          </Typography>
          <Box height="0.7rem" />
        </Box>
        <Box style={{ padding: "1rem 1.3rem" }}>
          <Grid container direction="row" justify="flex-end" style={{ padding: "10px" }}>
            <Grid item xs={2}>
              <Typography
                style={{ fontSize: "14px", color: TEXT.muted, lineHeight: "16px", letterSpacing: "0.02em", fontWeight: "500", cursor: "pointer" }}
                onClick={closeModal}
              >
                NO
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                style={{ fontSize: "14px", color: TEXT.info, lineHeight: "16px", letterSpacing: "0.02em", fontWeight: "500", cursor: "pointer" }}
                onClick={deleteDecision}
              >
                YES
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Popup>

      {/* ── Upload award type ── */}
      <Popup
        open={openAwardType}
        closeOnDocumentClick={!submittingAward}
        closeOnEscape={!submittingAward}
        onClose={closeModalAwardType}
        position="center"
        modal
        nested
        contentStyle={{ background: "white", width: "360px" }}
        overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
      >
        <Box style={{ padding: "1.2rem 1.5rem" }}>
          <Typography style={{ fontSize: "20px", color: TEXT.primary, fontWeight: "bold", lineHeight: "23px", letterSpacing: "0.0015em" }}>
            Upload Award
          </Typography>
          <Box height="0.5rem" />
          <Typography style={{ fontSize: "16px", color: TEXT.muted, lineHeight: "24px" }}>
            Is this Award an Interim Award or Final Award?
          </Typography>
          <Box height="1rem" />

          <FormControl required fullWidth size="small" margin="dense" variant="outlined">
            <InputLabel id="select-award-type-label">Award Type</InputLabel>
            <Select
              labelId="select-award-type-label"
              label="Award Type"
              value={selectedAwardType}
              onChange={handleAwardTypeChange}
            >
              <MenuItem value="partial_award">Interim</MenuItem>
              <MenuItem value="final_award">Final</MenuItem>
            </Select>
          </FormControl>

          {selectedAwardType === "final_award" && (
            <Box mt={2}>
              <Typography style={{ fontSize: "16px", color: TEXT.primary, fontWeight: "bold", marginBottom: "0.5rem" }}>
                Final Award Details
              </Typography>

              {awardParties.length > 0 ? (
                <FormControl required fullWidth size="small" margin="dense" variant="outlined">
                  <InputLabel>Award in Favour of</InputLabel>
                  <Select
                    label="Award in Favour of"
                    multiple={isMultiAwardParties}
                    value={isMultiAwardParties ? (Array.isArray(awardInFavourOf) ? awardInFavourOf : []) : (Array.isArray(awardInFavourOf) ? "" : awardInFavourOf)}
                    onChange={(e) => setAwardInFavourOf(e.target.value)}
                    renderValue={(selected) => {
                      if (isMultiAwardParties && Array.isArray(selected)) {
                        return (
                          <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                            {selected.map((val) => {
                              const p = awardParties.find((party) => party.value === val);
                              return (
                                <Chip
                                  key={val}
                                  label={p ? p.label : val}
                                  size="small"
                                  onMouseDown={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onDelete={() => {
                                    const newValue = selected.filter((v) => v !== val);
                                    setAwardInFavourOf(newValue);
                                  }}
                                />
                              );
                            })}
                          </Box>
                        );
                      }
                      const p = awardParties.find((party) => party.value === selected);
                      return p ? p.label : selected;
                    }}
                  >
                    {awardParties.map((party, index) => (
                      <MenuItem key={index} value={party.value}>
                        {isMultiAwardParties && (
                          <Checkbox
                            checked={
                              Array.isArray(awardInFavourOf) &&
                              awardInFavourOf.indexOf(party.value) > -1
                            }
                            size="small"
                            color="primary"
                            style={{ padding: "0 8px 0 0" }}
                          />
                        )}
                        {party.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  required
                  fullWidth
                  size="small"
                  margin="dense"
                  variant="outlined"
                  label="Award in Favour of"
                  value={awardInFavourOf}
                  onChange={(e) => setAwardInFavourOf(e.target.value)}
                />
              )}

              <TextField
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                label="Award Value (INR)"
                type="number"
                value={awardValue}
                onChange={(e) => {
                  if (isAllowedAmountInput(e.target.value)) setAwardValue(e.target.value);
                }}
              />

              <TextField
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                label="Applicable Stamp Duty (INR)"
                type="number"
                value={applicableStampDuty}
                onChange={(e) => {
                  if (isAllowedAmountInput(e.target.value)) setApplicableStampDuty(e.target.value);
                }}
              />
            </Box>
          )}
        </Box>
        <Box style={{ padding: "0.5rem 1.5rem 1.2rem" }}>
          <FormError message={awardError} style={{ marginTop: 0, marginBottom: "0.5rem" }} />
          <Grid container direction="row" justify="flex-end" style={{ padding: "10px" }}>
            <Grid item xs={4}>
              <Typography
                style={{ fontSize: "0.875rem", color: TEXT.muted, lineHeight: "16px", letterSpacing: "0.02em", fontWeight: "500", cursor: submittingAward ? "not-allowed" : "pointer" }}
                onClick={() => { if (!submittingAward) closeModalAwardType(); }}
              >
                CANCEL
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                color="primary"
                style={{ fontSize: "0.875rem", lineHeight: "16px", letterSpacing: "0.02em", fontWeight: "500", cursor: (submittingAward || !selectedAwardType) ? "not-allowed" : "pointer", textAlign: "right" }}
                onClick={() => { if (!submittingAward && selectedAwardType) handleAwardSubmit(); }}
              >
                {submittingAward ? "SUBMITTING..." : "SUBMIT"}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Popup>

      {/* ── Book Hearing Room ── */}
      <Popup
        open={openBookHearing}
        closeOnDocumentClick={false}
        closeOnEscape
        onClose={closeBookHearing}
        position="center"
        modal
        nested
        contentStyle={{ background: "white", width: "90vw", maxWidth: "640px", borderRadius: "4px", padding: "1.5rem", maxHeight: "90vh", overflowY: "auto" }}
        overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
      >
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginBottom: "1.2rem" }}>
            <Typography className={classes.disputeNameHeading}>Book Hearing Room</Typography>
            <Button onClick={closeBookHearing} className={classes.btnTextBlack} size="small">Close</Button>
          </Box>

          <BookHearingRoom
            disputeId={disputeId}
            initialStage={bookHearingPrefill ? '' : (activeDispute?.arbitration_stage?.id || '')}
            initialDate={bookHearingPrefill?.date || ''}
            isAdmin={false}
          // onBookingSuccess={reload}
          />
        </Box>
      </Popup>

      {/* ── Draft Order Editor ── */}
      <Popup
        open={openDraftOrder}
        closeOnDocumentClick={false}
        closeOnEscape
        onClose={() => {
          setOpenDraftOrder(false);
          setEditingDraft(null);
          setTranscribeError('');
          setRecorderUiState('idle');
          setProofreadState('idle');
          setProofreadMessage('');
          setSaveDraftStatus(null);
          setSaveDraftMsg('');
        }}
        position="center"
        modal
        nested
        // A definite height and a flex column, so the sheet fills it
        // (fillHeight) and only the document scrolls - the toolbar stays in
        // view. overflowY is a fallback for a window too short for even the
        // sheet's minimum.
        contentStyle={
          draftFullscreen
            ? { background: "white", width: "100vw", maxWidth: "none", height: "100vh", maxHeight: "100vh", overflowY: "auto", borderRadius: 0, padding: "1.5rem", boxSizing: "border-box", display: "flex", flexDirection: "column" }
            : { background: "white", width: "90vw", maxWidth: "900px", height: "90vh", overflowY: "auto", borderRadius: "4px", padding: "1.5rem", boxSizing: "border-box", display: "flex", flexDirection: "column" }
        }
        overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
      >
        <Box display="flex" flexDirection="column" flex="1 1 auto" minHeight={0}>
          {/* Editor header */}
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginBottom: "0.6rem" }}>
            <Typography className={classes.disputeNameHeading}>
              {editingDraft ? `Editing: ${editingDraft.title}` : 'New Draft'}
            </Typography>
            <Box display="flex" alignItems="center" style={{ gap: "0.5rem", flexWrap: "wrap" }}>
              {/* AI Proofread */}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={proofreadState === 'loading'}
                onClick={handleProofread}
                style={{ textTransform: "none", minWidth: "110px" }}
              >
                {proofreadState === 'loading' ? (
                  <Box display="flex" alignItems="center" style={{ gap: "0.4rem" }}>
                    <CircularProgress size={13} color="inherit" />
                    <span>Reviewing...</span>
                  </Box>
                ) : 'AI Proofread'}
              </Button>

              {/* Save Draft */}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={draftActionLoading}
                onClick={() => runDraftAction('save')}
                style={{ textTransform: "none" }}
              >
                Save Draft
              </Button>

              {/* Download */}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={draftActionLoading}
                onClick={() => runDraftAction('download')}
                style={{ textTransform: "none" }}
              >
                Download
              </Button>

              {/* Inline label rather than TextField's floating one: an outlined
                  field is 40px tall even at size="small", next to ~26px buttons,
                  and squeezed to their height the floating label crowds the value. */}
              <Box
                component="label"
                display="flex"
                alignItems="center"
                title="Number on the first page of the printout and download; later pages continue from it"
                style={{ gap: '0.35rem' }}
              >
                <Typography
                  component="span"
                  style={{ fontSize: '0.8125rem', color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'nowrap' }}
                >
                  Start page
                </Typography>
                <TextField
                  type="number"
                  size="small"
                  variant="outlined"
                  value={startPage}
                  onChange={(e) => setStartPage(e.target.value)}
                  onBlur={() => setStartPage(String(startPageNumber(startPage)))}
                  // Same font and height as the size="small" buttons beside it.
                  InputProps={{ style: { fontSize: '0.8125rem', lineHeight: 1.4 } }}
                  inputProps={{
                    min: 1,
                    max: 100000000,
                    'aria-label': 'Start page number',
                    style: { padding: '4px 8px', height: 'auto' },
                  }}
                  style={{ width: 90 }}
                />
              </Box>

              {/* Print - the sheet as it stands, via the browser's print dialog */}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  const html = editorRef.current ? editorRef.current.getContent() : '';
                  printOrderSheet(html, editingDraft?.title || 'Order Sheet', {
                    caseNumber: caseNumberRef.current,
                    startPage: startPageNumber(startPage),
                  }).catch((err) => {
                    console.error('Failed to open the print window:', err);
                    setSaveDraftStatus('error');
                    setSaveDraftMsg('Could not open the print window. Please try again.');
                  });
                }}
                style={{ textTransform: "none" }}
              >
                Print
              </Button>

              <FullscreenToggle
                fullscreen={draftFullscreen}
                onToggle={() => setDraftFullscreen((v) => !v)}
              />

              {/* Close */}
              <Button
                onClick={() => {
                  setOpenDraftOrder(false);
                  setEditingDraft(null);
                  setTranscribeError('');
                  setRecorderUiState('idle');
                  setProofreadState('idle');
                  setProofreadMessage('');
                  setSaveDraftStatus(null);
                  setSaveDraftMsg('');
                }}
                className={classes.btnTextBlack}
              >
                Close
              </Button>
            </Box>
          </Box>

          {/* The order sheet. Editable throughout, as it was under TinyMCE. */}
          <OrderSheetEditor
            key={editorSession}
            value={orderHtml}
            onChange={applyOrderHtml}
            preset={orderPreset}
            toolbar={ORDER_TOOLBAR}
            fillHeight
            // Ctrl+S / Ctrl+P do what the Save Draft and Print buttons do,
            // including Save Draft's guard against a save already in flight.
            onSave={() => {
              if (!draftActionLoading) runDraftAction('save');
            }}
            onPrint={(html) => {
              printOrderSheet(html, editingDraft?.title || 'Order Sheet', {
                caseNumber: caseNumberRef.current,
                startPage: startPageNumber(startPage),
              }).catch((err) => {
                console.error('Failed to open the print window:', err);
                setSaveDraftStatus('error');
                setSaveDraftMsg('Could not open the print window. Please try again.');
              });
            }}
            customItems={orderToolbarItems}
            onLinkClick={handleOrderLinkClick}
            onActiveEditorChange={(editor) => {
              activeOrderEditorRef.current = editor;
            }}
            onReady={(editors) => {
              orderEditorsRef.current = editors;
              focusOrderRegion();
            }}
          />

          {/* Save, proofread and recorder feedback, gathered into one sticky
              strip below the sheet. These share the dialog body's scroll with
              the order, so without this they scroll out of sight exactly when
              they matter. */}
          <Box className="order-sheet__status">
            {/* Save draft feedback */}
            {saveDraftMsg && (
              <Typography style={{
                fontSize: "13px",
                fontFamily: `"Noto Sans", sans-serif`,
                marginBottom: "0.4rem",
                color: saveDraftStatus === 'error' ? '#d32f2f' : '#2e7d32',
              }}>
                {saveDraftMsg}
              </Typography>
            )}

            {/* Proofread feedback */}
            {proofreadMessage && (
              <Typography style={{
                fontSize: "13px",
                fontFamily: `"Noto Sans", sans-serif`,
                marginBottom: "0.5rem",
                color: proofreadState === 'error' ? '#d32f2f' : '#2e7d32',
              }}>
                {proofreadMessage}
              </Typography>
            )}

            {/* Recorder status */}
            {recorderUiState === 'recording' && (
              <Box display="flex" alignItems="center" style={{ gap: "0.5rem", marginTop: "0.5rem" }}>
                <span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", background: "#d32f2f", animation: "tinymce-mic-pulse 1s infinite" }} />
                <Typography style={{ color: TEXT.error, fontSize: "13px" }}>
                  Recording… Click the microphone button again to stop.
                </Typography>
                <style>{`@keyframes tinymce-mic-pulse { 0%,100%{opacity:1} 50%{opacity:0.2} }`}</style>
              </Box>
            )}
            {recorderUiState === 'transcribing' && (
              <Box display="flex" alignItems="center" style={{ gap: "0.5rem", marginTop: "0.5rem" }}>
                <CircularProgress size={14} />
                <Typography style={{ color: TEXT.secondary, fontSize: "13px" }}>
                  Transcribing audio…
                </Typography>
              </Box>
            )}
            {transcribeError && (
              <Typography style={{ color: TEXT.error, fontSize: "13px", marginTop: "0.4rem" }}>
                {transcribeError}
              </Typography>
            )}
          </Box>

        </Box>
      </Popup>

    </Grid>
  );
}